// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
// Global colors for components
const ROW_COLORS = ['#F8F8F8', '#fff'];

function TableSelectedParts({ parts }) {
  const { t } = useTranslation('storage');
  if (!parts || parts.length === 0) {
    return null;
  }

  return (
    <>
      <hr />
      <div className="col-collapse col-md-12 col-12 none-border">
        <h6 className="bold">{t("authorizedMaintenanceComponents")}</h6>
      </div>
      <div className="col-collapse col-md-12 col-12 table-component">
        <Table
          striped
          bordered
          responsive
          hover
          size="sm"
          className="mt-3"
          style={{ borderRadius: '12px'}}
        >
          <thead>
            <tr>
              <th>{t('code')}</th>
              <th>{t('component')}</th>
              <th>{t('description')}</th>
              <th>{t('quantity')}</th>
            </tr>
          </thead>
          <tbody>
            {parts.map((part, index) => {
              const rowColor = ROW_COLORS[index % ROW_COLORS.length];
              return (
                <tr key={index} style={{ backgroundColor: rowColor }}>
                  <td>{part.code}</td>
                  <td>{part.component}</td>
                  <td>{part.description}</td>
                  <td>{part.quantity}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}

TableSelectedParts.propTypes = {
  parts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // ID
      code: PropTypes.string.isRequired, // Visible name
      component: PropTypes.string.isRequired, // Component name
      description: PropTypes.string.isRequired, // Component name
      quantity: PropTypes.number.isRequired, // Quantity
    })
  ),
};

TableSelectedParts.defaultProps = {
  parts: [],
};


export default  TableSelectedParts ;
